import { createContext } from 'react'

export const defaultCharacterRef = (pageInfo: wowaudit.PageInfo) => {
  let foundCharacter: wowaudit.CharacterReference | undefined
  const storedCharacterId = parseInt(
    localStorage.getItem('currentCharacterId') || '',
  )

  if (storedCharacterId) {
    foundCharacter = pageInfo.user?.characterReferences?.find(
      (character) => character.id === storedCharacterId,
    )
  }
  if (foundCharacter) return foundCharacter

  localStorage.removeItem('currentCharacterId')
  foundCharacter = pageInfo.user?.characterReferences?.find(
    (character) => character.main,
  )

  return foundCharacter
}

export interface AppContextType {
  customDomain?: wowaudit.CustomDomain
  setCustomDomainPreview: (customDomain?: wowaudit.CustomDomain) => void
  currentCharacterRef?: wowaudit.CharacterReference
  setCurrentCharacterRef: (
    character: wowaudit.CharacterReference | undefined,
  ) => void
}

export const AppContext = createContext<AppContextType>({
  customDomain: undefined,
  setCustomDomainPreview: () => {},
  setCurrentCharacterRef: () => {},
})

export default AppContext
